<template>
    <div>
        <ul class="timeline mt-5 ">
            <li
                class="mt-0"
                :class="{
                    'd-none':
                        donor_ == 0 &&
                        (update.tags.includes('Thanks') ||
                            update.tags.includes('Downloads'))
                }"
                v-for="update in updates"
                v-bind:key="update.title + update.id"
            >
                <div>
                    <div
                        class="imgs"
                        :style="{
                            'background-image':
                                'url(/storage/' + update.img + ')'
                        }"
                    ></div>
                    <div class="date-posted-top d-block d-md-none">
                        <p class="mb-0">
                            {{ update.created_at | moment("D MMM YYYY") }}
                        </p>
                    </div>
                    <div>
                        <p class="date-posted d-none d-md-block">
                            {{ update.created_at | moment("D MMM YYYY") }}
                        </p>
                        <div>
                            <a
                                :href="
                                    update.tags.includes('Story')
                                        ? '/stories/' + update.slug
                                        : '#'
                                "
                                class="update-title"
                                >{{ update.title }}</a
                            >
                        </div>
                        <div class="tags">
                            <span
                                href="#"
                                class="tag mb-2 mr-1"
                                v-for="tags in update.tags.split(',')"
                                v-bind:key="update.title + tags"
                                v-bind:class="{
                                    'story-tags': tags == 'Story',
                                    'exclusive-content-tags':
                                        tags == 'Exclusive content',
                                    milestone: tags == 'Milestone',
                                    'contribution-tags':
                                        tags == 'Thanks for your contribution!',
                                    'field-updates-tags':
                                        tags == 'Field updates'
                                }"
                                >{{ tags }}</span
                            >
                            <span
                                href="#"
                                class="tag mb-2 mr-1"
                                v-for="adoptee in update.adoptees"
                                v-bind:key="adoptee.id"
                                :style="[{ background: adoptee.species_color }]"
                                >{{ adoptee.name }}</span
                            >
                        </div>
                        <div v-if="hideUpdate(update)" class="desc mb-0">
                            <h4>Become a hero to unlock the latest updates!</h4>
                            <p class="desc">
                                This update is locked exclusive for Wildlife
                                Hero accounts. Become a hero to unlock the
                                latest updates!
                            </p>
                        </div>
                        <p v-else class="desc">
                            <read-more
                                more-str="Read more"
                                :text="update.body"
                                :link="
                                    update.tags.includes('Story')
                                        ? '/stories/' + update.slug
                                        : '#'
                                "
                                less-str="Read less"
                                :max-chars="150"
                                v-bind:class="{
                                    'story-link': update.tags.includes('Story')
                                }"
                            ></read-more>
                        </p>
                    </div>
                </div>
            </li>
        </ul>
        <div class="text-center">
            <button
                class="load-more"
                @click="getUpdates"
                :class="{ 'd-none': last_page == current_page }"
                style="border-radius: 7px"
            >
                LOAD MORE
            </button>
        </div>
    </div>
</template>
<script>
export default {
    props: ["donor", "adoptions"],
    data() {
        return {
            updates: [],
            last_page: 0,
            current_page: 0,
            donor_: this.donor
        };
    },
    created() {
        this.getUpdates();
    },
    methods: {
        hideUpdate(update) {
            var ret = true;
            // if it's not an update don't hide it
            if (!update.tags.includes("Field updates")) {
                return false;
            }
            // if the user doesn't has any adoptions yet hide it
            if (!this.adoptions.length) {
                return true;
            }
            update.adoptees.forEach(adoptee => {
                // if the user has adopted the adoptee with update don't hide it
                if (this.adoptions.includes(adoptee.id)) ret = false;
            });
            return ret;
        },
        strip_html(value) {
            var div = document.createElement("div");
            div.innerHTML = value;
            var text = div.textContent || div.innerText || "";
            return text;
        },
        getUpdates() {
            let next_page = this.current_page + 1;
            this.current_page = next_page;
            fetch("/user/dashboard_updates?page=" + next_page)
                .then(res => res.json())
                .then(res => {
                    this.last_page = res.last_page;
                    for (let x = 0; x < res.data.length; x++) {
                        this.updates.push(res.data[x]);
                    }
                })
                .catch(err => console.log(err));
        }
    }
};
</script>
<style scoped>
/* TIMELINE */
ul.timeline {
    list-style-type: none;
    position: relative;
    padding-left: 0;
}
ul.timeline:before {
    content: " ";
    background: #d4d9df;
    display: inline-block;
    position: absolute;
    left: 150px;
    top: 90px;
    width: 4px;
    height: 100%;
    z-index: 400;
    background-color: black;
}
ul.timeline > li {
    margin: 50px 0;
    padding: 15px 20px 30px 220px;
    background-color: #f9f9f9;
    position: relative;
}
ul.timeline > li.notice {
    background-color: #fffbdb;
}
.imgs {
    content: " ";
    background: white;
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    /* border: 3px solid #22c0e8; */
    background-size: cover;
    background-position-y: left;
    background-position-x: center;
    left: 100px;
    width: 100px;
    height: 100px;
    z-index: 400;
}
ul.timeline .date-posted {
    position: absolute;
    left: 0px;
    top: 50px;
    background-color: #e9e9e9;
    font-size: 0.9em;
    padding: 5px;
}
.update-title {
    font-size: 1.3em;
    font-weight: bolder;
    color: black;
}
.tags {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    margin-bottom: 10px;
}
.tags .tag {
    border-radius: 4px;
    color: white;
    font-size: 0.8em;
    padding: 5px 10px;
}
.load-more {
    border: none;
    font-weight: bolder;
    font-size: 1.2em;
    padding: 10px 15px;
    background-color: #5a9fba;
    color: white;
}
.story-tags {
    background-color: black;
}
.exclusive-content-tags {
    background-color: #ffc600;
    color: black !important;
}
.field-updates-tags {
    background-color: #007932;
}
.contribution-tags {
    background-color: #f1ebdd;
    color: black !important;
}
.milestone {
    background-color: #f07d00;
}

.desc * {
    font-weight: normal;
    font-size: 1rem;
    font-style: normal;
}
@media only screen and (max-width: 768px) {
    ul.timeline > li {
        padding: 15px 20px 50px 80px;
    }
    .update-title {
        font-size: 1em;
    }
    .desc {
        font-size: 0.9em;
    }
    .tags .tag {
        font-size: 0.7em;
    }
    ul.timeline:before {
        height: 95%;
        top: 50px;
        left: 40px;
    }
    .imgs {
        left: 10px;
        width: 60px;
        height: 60px;
    }
    ul.timeline .date-posted-top {
        padding: 0 0 0 0 !important;
        position: relative;
        top: -42px;
    }
    ul.timeline .date-posted-top p {
        background-color: #e9e9e9;
        font-size: 0.8em;
        padding: 5px 10px;
        width: fit-content;
    }
}
</style>
